import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Products
 */
export const ExportVariantsWithLongNameContentType = '' as const;
export type ExportVariantsWithLongNameRequest = void;
export type ExportVariantsWithLongNameResponses = LinkCommonErrorResponses & {
    /**
     * @description Exported products data
     */
    '200': {
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': string;
    };
};
export type ExportVariantsWithLongNameResponseSuccess =
    ExportVariantsWithLongNameResponses['200']['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
export type ExportVariantsWithLongNameSearchParams = undefined;
export type ExportVariantsWithLongNamePathParameters = undefined;
export const ExportVariantsWithLongNameUrl = '/products/export/long-name' as const;
export const ExportVariantsWithLongNameMethod = 'POST' as const;
export const getExportVariantsWithLongNameUrl = (_params?: ExportVariantsWithLongNamePathParameters) =>
    ExportVariantsWithLongNameUrl;
